import {
  ApdmCampaignKind,
  ApdmCampaignVersionRef,
  ApdmSendState,
} from './campaign';

export enum ApdmDraftKind {
  FollowUp = 'follow_up',
  Reply = 'reply',
}

export const ApdmDraftKindValueSet = new Set([
  ApdmDraftKind.FollowUp,
  ApdmDraftKind.Reply,
]);

export enum ApdmDraftStatus {
  Pending = 'pending',
  Approved = 'approved',
  Sent = 'sent',
  Discarded = 'discarded',
  Expired = 'expired',
  Failed = 'failed',
}

export const ApdmDraftStatusValueSet = new Set([
  ApdmDraftStatus.Pending,
  ApdmDraftStatus.Approved,
  ApdmDraftStatus.Sent,
  ApdmDraftStatus.Discarded,
  ApdmDraftStatus.Expired,
  ApdmDraftStatus.Failed,
]);

export enum RpaMessageType {
  Text = 'text',
  Image = 'image',
  Video = 'video',
  Link = 'link',
  Voice = 'voice',
  Miniprogram = 'miniprogram',
  Other = 'other',
}

export const RpaMessageTypeValueSet = new Set([
  RpaMessageType.Text,
  RpaMessageType.Image,
  RpaMessageType.Video,
  RpaMessageType.Link,
  RpaMessageType.Voice,
  RpaMessageType.Miniprogram,
  RpaMessageType.Other,
]);

export type RpaReplyIntent =
  | 'service_status'
  | 'service_progress'
  | 'finish_time'
  | 'findings'
  | 'construction_info'
  | 'service_items'
  | 'greeting'
  | 'escalate'
  | 'opt_out'
  | 'out_of_scope'
  | 'campaign_inquiry'
  | 'campaign_booking'
  | 'campaign_not_interested';
export type ApdmCampaignReviewIntent = Extract<
  RpaReplyIntent,
  | 'campaign_inquiry'
  | 'campaign_booking'
  | 'campaign_not_interested'
  | 'greeting'
  | 'opt_out'
>;
export const apdmReplyOutputCharacterLimit = 500;

export interface ApdmReplyDraftRef extends ApdmCampaignVersionRef {
  draftId: string;
}

export interface ApdmApproveReplyDraftInput {
  ref: ApdmReplyDraftRef;
  expectedFingerprint: string;
}

export interface ApdmEditReplyDraftInput extends ApdmApproveReplyDraftInput {
  text: string;
}

export type ApdmDiscardReplyDraftInput = ApdmApproveReplyDraftInput;

export enum ApdmDraftReviewScope {
  Reviewer = 'reviewer',
  Campaign = 'campaign',
}

export interface ApdmReplyDraftReviewListInput {
  scope?: ApdmDraftReviewScope;
  campaignId: string | null;
  afterDraftId: string | null;
  status: ApdmDraftStatus | null;
  limit: number;
}

export interface ApdmReplyDraftReviewDetailInput {
  draftId: string;
}

export interface ApdmReplyDraftReviewSummary {
  canReview?: boolean;
  reviewerName?: string | null;
  ref: ApdmReplyDraftRef;
  campaignTitle: string;
  campaignKind: ApdmCampaignKind;
  licensePlateNo: string;
  kind: ApdmDraftKind;
  status: ApdmDraftStatus;
  sendState: ApdmSendState;
  text: string;
  fingerprint: string;
  createdAt: string;
  expiresAt: string;
}

export interface ApdmReplyDraftReviewListResult {
  rows: ApdmReplyDraftReviewSummary[];
  nextAfterDraftId: string | null;
}

export interface ApdmReplyDraftReviewMessage {
  id: string;
  sender: 'customer' | 'staff' | 'rpa';
  type: RpaMessageType;
  text: string | null;
  sentAt: string;
}

export interface ApdmReplyDraftReviewDetailResult {
  draft: ApdmReplyDraftReviewSummary;
  recipientId: string;
  pausedUntil: string | null;
  intent: ApdmCampaignReviewIntent | null;
  reason?: 'follow_up';
  offerText: string[];
  messages: ApdmReplyDraftReviewMessage[];
}

export interface ApdmReplyDraftReviewActionResult {
  draftId: string;
}
